import type { IconData } from '@stacksjs/iconify-core'

export const target3Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M1.5 24c0 12.426 10.074 22.5 22.5 22.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5S1.5 11.574 1.5 24\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M6 24c0-9.941 8.059-18 18-18s18 8.059 18 18s-8.059 18-18 18S6 33.941 6 24m31.858-2H36a2 2 0 1 0 0 4h1.858C36.981 32.131 32.131 36.981 26 37.858V36a2 2 0 1 0-4 0v1.858C15.869 36.981 11.019 32.131 10.142 26H12a2 2 0 1 0 0-4h-1.858c.877-6.131 5.727-10.981 11.858-11.858V12a2 2 0 1 0 4 0v-1.858c6.131.877 10.981 5.727 11.858 11.858\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M19 24a2 2 0 0 0 2 2h1v1a2 2 0 1 0 4 0v-1h1a2 2 0 1 0 0-4h-1v-1a2 2 0 1 0-4 0v1h-1a2 2 0 0 0-2 2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default target3Flat
